import { useAppDispatch, useAppSelector } from '@hook/index';
import { Layout } from 'antd';
import React, { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import HeaderComponent from './Header';
import './style.scss';
import { getCurrentUser } from '@store/authSlice';
import MenuHeader from './Menu';
import Footer from './Footer';
import { handleChangeTypeChat, handleResize } from '@store/commonSlice';
import Subfooter from './SubFooter';
import { getHeader } from '@store/homeSlice';
import Loading from '@components/common/loading';
import RouteFallback from '@components/common/route-fallback';
import ScrollToTop from '@components/common/scroll';
import { getSetting } from '@store/settingSlice';
import Maintenance from '@components/maintenance';
import { EventHandlerPayload, LiveChatWidget } from '@livechat/widget-react';
type Props = {};

const DefaultLayout: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const { size, typeChat } = useAppSelector((state) => state.commonSlice);
  const { data: dataSetting } = useAppSelector((state) => state.settingSlice);
  const { data: dataAuth } = useAppSelector((state) => state.authSlice);
  const { Header, Content } = Layout;
  const { pathname } = useLocation();
  useEffect(() => {
    if (location.pathname.split('/')[location.pathname.split('/').length - 1].includes('undefined')) {
      navigate('/notfound');
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  const callback = () => {};
  useEffect(() => {
    if (dataAuth?.isLogin) dispatch(getCurrentUser({ callback }));
  }, []);
  useEffect(() => {
    dispatch(handleResize(window.innerWidth));
    const setSize = () => {
      dispatch(handleResize(window.innerWidth));
    };
    window.addEventListener('resize', setSize);
    return () => window.removeEventListener('resize', setSize);
  }, []);
  useEffect(() => {
    dispatch(getHeader());
    dispatch(getSetting());
  }, []);
  const handleHide = ({ visibility }) => {
    dispatch(handleChangeTypeChat(visibility));
  };
  if (!dataSetting.listSetting)
    return (
      <>
        {' '}
        <Loading loadingDefault={true} />
      </>
    );

  if (!Number(dataSetting.listSetting?.web_status)) {
    return (
      <>
        <Maintenance />
      </>
    );
  }
  return (
    <>
      <Loading />
      <Layout className="layout-default layout-home">
        <LiveChatWidget license="13227897" onVisibilityChanged={handleHide} visibility={typeChat} />
        <HeaderComponent />
        <MenuHeader />
        <div className="layout-full" style={{ background: 'black', display: 'flex', justifyContent: 'center' }}>
          <div className="hot-news layout-max">
            <div className="title">Tin nóng</div>
          </div>
        </div>

        <Content style={{ position: 'relative' }}>
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </Content>
        <Footer />
      </Layout>
      <ScrollToTop />
    </>
  );
};

export default DefaultLayout;
